import React from 'react';
import { Icon } from './Icon.js';
export const IconCylinderFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M13.5,4.25v7.636c-2.306-1.125-6.694-1.125-9,0V4.25h-1.5V13.75c0,1.805,3.019,2.75,6,2.75s6-.945,6-2.75V4.25h-1.5Zm-4.5,10.75c-2.953,0-4.5-.929-4.5-1.25s1.547-1.25,4.5-1.25,4.5,.929,4.5,1.25-1.547,1.25-4.5,1.25Z", fill: "currentColor" }),
        React.createElement("path", { d: "M3,4.25c0,1.805,3.019,2.75,6,2.75s6-.945,6-2.75C15,.64,3,.64,3,4.25Z", fill: "currentColor", "data-color": "color-2" })));
};
//# sourceMappingURL=IconCylinderFill18.js.map